// /c/:alias — link curto do cardápio. Descobre de qual loja é o apelido e abre o cardápio.
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { collection, getDocs, query, where, limit } from 'firebase/firestore';
import { db } from '../../Confg/firebaseConfig';
import { getApiUrl, whenAppConfigReady } from '../../Confg/appConfig';
import { limparAlias } from '../../utils/linkCardapio';

// Pelo backend (Admin SDK): funciona para o cliente sem login e conta a visualização.
async function lojaPeloBackend(alias) {
  await whenAppConfigReady();
  const res = await fetch(`${getApiUrl()}/api/public/cardapio-link/${encodeURIComponent(alias)}`);
  if (!res.ok) return null;
  const data = await res.json().catch(() => null);
  return data?.merchantId || null;
}

// Reserva enquanto o backend não tem a rota: lê direto a loja (campo novo e o antigo).
async function lojaPeloFirestore(alias) {
  const lojas = collection(db, 'merchants');
  for (const campo of ['linkCardapio.alias', 'alias']) {
    const snap = await getDocs(query(lojas, where(campo, '==', alias), limit(1)));
    if (!snap.empty) return snap.docs[0].id;
  }
  return null;
}

const RedirectToMenu = () => {
  const { alias: bruto } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const alias = limparAlias(bruto);
    let cancelado = false;

    (async () => {
      let merchantId = null;
      try {
        merchantId = await lojaPeloBackend(alias);
      } catch (error) {
        console.warn('Link do cardápio: backend indisponível, tentando direto.', error?.message);
      }
      if (!merchantId) {
        try {
          merchantId = await lojaPeloFirestore(alias);
        } catch (error) {
          console.warn('Link do cardápio: consulta direta negada.', error?.code || error?.message);
        }
      }
      if (cancelado) return;
      navigate(merchantId ? `/merchants/${merchantId}/cardapio` : '/not-found', { replace: true });
    })();

    return () => { cancelado = true; };
  }, [bruto, navigate]);

  return <div>Abrindo o cardápio…</div>;
};

export default RedirectToMenu;
